// @flow

// Constants
import { UPDATE_STEP, CLEAR_EVERYTHING } from "@src/actions";

const defaultState = {
  stepsMeta: {
    activeStep: 0,
    activeSubStep: 0,
    totalParentSteps: 3
  }
};

// Main Reducers
export default function sideBar(state = defaultState, action) {
  switch (action.type) {
    case UPDATE_STEP:
      return {
        ...state,
        stepsMeta: {
          ...state.stepsMeta,
          activeStep: action.activeStep,
          activeSubStep: action.activeSubStep
        }
      };
    case CLEAR_EVERYTHING:
      return {
        ...defaultState
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/sideBar/index.js